import type { Major } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const STRINGS = appStrings.modules.majors.academicExperience;

export const useAgentContext = (major: Major) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Academic Experience',
    description:
      'Attributes rating this major across demand, option value, rigor, specialization, competitiveness, and workload intensity',
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Academic Experience Attributes',
    display:
      'Row cards with labeled scale indicators showing where the major falls on each attribute',
    detail: [
      STRINGS.demandInfo,
      STRINGS.optionValueInfo,
      STRINGS.rigorInfo,
      STRINGS.specializationInfo,
      STRINGS.competitivenessInfo,
      STRINGS.workloadIntensityInfo,
    ].join('\n\n'),
    data: {
      demand: major.demand,
      optionValue: major.optionValueName,
      rigor: major.rigor,
      specialization: major.specialization,
      competitiveness: major.competitiveness,
      workload: major.workload,
    },
  });
};
